import * as yup from 'yup';
import { ONLY_DIGIT_PERMITED_PATH, ONLY_LETTERS_ENGLISH_PERMITED_PATH, REQUIRED_FIELD_PATH } from '../../errorMessages';
import { onlyEnglishAndSpace, onlyNumbersRegExp } from '../../../helpers/regExps';


export const yupObjectCreditCardNotRequired = {
    cardNumber: yup.string()
        .notRequired(),
    cardExpireDateYY: yup.string()
        .notRequired(),
    cardExpireDateMM: yup.string()
        .notRequired(),
    cardAddedNumber: yup.string()
        .notRequired(),
    cardHolderId: yup.string()
        .notRequired()
}

export const yupObjectCreditCardRequired = {
    cardNumber: yup.string()
        .matches(onlyNumbersRegExp, ONLY_DIGIT_PERMITED_PATH)
        .required(REQUIRED_FIELD_PATH),
    cardExpireDateYY: yup.string()
        .notOneOf(['-1'], REQUIRED_FIELD_PATH)
        .required(REQUIRED_FIELD_PATH),
    cardExpireDateMM: yup.string()
        .notOneOf(['-1'], REQUIRED_FIELD_PATH)
        .required(REQUIRED_FIELD_PATH),
    cardAddedNumber: yup.string()
        .matches(onlyNumbersRegExp, ONLY_DIGIT_PERMITED_PATH)
        .required(REQUIRED_FIELD_PATH),
    cardHolderId: yup.string()
        .matches(onlyNumbersRegExp, ONLY_DIGIT_PERMITED_PATH)
        .required(REQUIRED_FIELD_PATH),
    cardHolderName: yup.string()
        .matches(onlyEnglishAndSpace, ONLY_LETTERS_ENGLISH_PERMITED_PATH)
        .required(REQUIRED_FIELD_PATH),
}